import axiosInstance from "./axiosInstance.ts";

type GetSoldVBCUnitsParams = {
  clientId: string;
  solutionId: string;
  page?: number;
  limit?: number;
};

const getSoldVBCUnits = async ({
  clientId,
  solutionId,
  page = 1,
  limit = 10,
}: GetSoldVBCUnitsParams) => {
  const response = await axiosInstance.get("/v3/biodiversity/units/sold", {
    params: {
      clientId,
      solutionId,
      page,
      limit,
    },
  });
  return (
    response?.data || {
      data: [],
      pagination: { page: 1, limit: 10, totalItems: 0, totalPages: 0 },
    }
  );
};

export default getSoldVBCUnits;
